<div class="w-full h-full" *ngIf="selectedDispatchTab === 'JOBS'">
    <!-- Jobs -->
    <div class="w-full h-full board-with-nav">
        <!-- Navbar -->
        <nav class="bg-white shadow border-b">
            <div class="mx-auto px-4">
                <div class="flex justify-between h-16 my-auto">
                    <div class="flex gap-4 my-auto items-center">
                        <div class="space-x-4 ng-star-inserted">
                            <div class="flex items-center justify-center bg-gray-100 rounded-md py-1 px-1 h-12"
                                [hidden]="!moduleAccess.map || !enableRoutesTab">
                                <button (click)="onToggleDispatchTab('JOBS', '')"
                                    class="h-10 m-1 px-6 rounded-md py-1 transition flex items-center text-center justify-center bg-white shadow-sm font-semibold">
                                    <img class="w-6 h-7 mr-2" src="/assets/images/svgs/briefcase-solid.svg" alt="">
                                    {{'text.jobs' | translate}}</button>
                                <button (click)="onToggleDispatchTab('ROUTES', 'TRACKING')"
                                    class="h-10 m-1 px-6 rounded-md py-1 font-medium transition flex items-center text-center justify-center border-ui-tertiary hover:bg-gray-200">
                                    <img class="w-6 h-7 mr-2" src="/assets/images/svgs/map.svg" alt="">
                                    {{'text.routes'| translate}}</button>
                            </div>
                            <div class="flex items-center" [hidden]="moduleAccess.map && enableRoutesTab">
                                <span class="font-semibold text-2xl text-gray-700 cursor-default">{{'dispatch.nav.title'
                                    | translate}}</span>
                            </div>
                        </div>

                        <!-- Custom timezone -->
                        <div class="flex items-center my-auto relative h-11 p-2 border border-gray-300 rounded-lg"
                            *ngIf="_dispatchBoardService?.companyConfig?.multipleTimezone">
                            <i class="ti ti-clock text-2xl mt-1 text-gray-700"
                                title="{{'text.timezone' | translate}}"></i>
                            <ng-select #dispatchCustomTimezone class="w-48 custom_timezone cursor-pointer static dispatchPicker"
                                [(ngModel)]="_dispatchBoardService.customTimezone" [clearable]="false" [multiple]="false" [hideSelected]="false"
                                [virtualScroll]="true"
                                (change)="dispatchCustomTimezone.blur(); onCustomTimezoneChange();">
                                <ng-option *ngFor="let timezone of _dispatchBoardService.timezones | async" [value]="timezone.key"><span title="{{timezone.name}}">{{timezone.name}}</span></ng-option>
                            </ng-select>
                        </div>

                        <!-- Service territory -->
                        <div class="flex items-center my-auto relative h-11 p-2 border border-gray-300 rounded-lg" *ngIf="enableServiceTerritory">
                            <i class="ti ti-compass text-2xl mt-1 text-gray-700"
                                title="{{'text.service_territories' | translate}}"></i>
                            <ng-select #serviceTerritoryPicker class="w-48 service-territory-picker cursor-pointer static dispatchPicker"
                                [(ngModel)]="selectedServiceTerritory" [clearable]="false" [multiple]="false" [hideSelected]="false"
                                placeholder="{{'text.choose_a_service_territory' | translate}}"
                                [items]="serviceTerritories | async" bindLabel="territory_name" bindValue="territory_uid" [searchable]="true" 
                                [closeOnSelect]="true" (open)="onServiceTerritoryPickerOpen()" [virtualScroll]="true"
                                [notFoundText]="'dispatchBoard.navbar.service_territory.placeholder' | translate"
                                [loading]="territorySearchPagination.isLoading" [typeahead]="serviceTerritoryValueSubject" (search)="onServiceTerritorySearch()"
                                (scrollToEnd)="serviceTerritoryPickerScrollToEnd()" (change)="serviceTerritoryPicker.blur();onServiceTerritoryChange($event)">
                            </ng-select>
                        </div>
                    </div>
                    <div class="sm:ml-6 sm:flex sm:items-center my-auto gap-4">
                        <div class="flex quickFilter">
                            <ng-select #quickFilter id="dispatch_filter_select" name="filter"
                                class="text-base min-w-50 max-w-64 quickFilterDropDown dispatchPicker"
                                [(ngModel)]="selectedQuickFilter" [multiple]="false" [clearable]="false"
                                [searchable]="false" [hideSelected]="false" [appendTo]="'body'" [closeOnSelect]="true"
                                (change)="onQuickFilterChange($event, false, false)" [loading]="quickFilterLoading">
                                <ng-option [value]="'ALL'">{{'dispatchBoard.navbar.default_filter' |
                                    translate}}</ng-option>
                                <ng-option *ngFor="let filter of quickFilters"
                                    [value]="filter.filter_uid">{{filter.filter_name}}</ng-option>
                                <ng-template ng-footer-tmp>
                                    <button (click)="quickFilter.close();addNewDispatchFilter()" [value]="'ADD'"
                                        class="w-full sticky z-10 bottom-0 bg-card text-base px-1.5 py-2 hover:bg-gray-100">
                                        <div class="flex justify-between">
                                            <div><em class="ti ti-plus"></em> {{'dispatchBoard.navbar.filter.add_filter'
                                                | translate}}</div>
                                            <div class="mt-1"></div>
                                        </div>
                                    </button>
                                    <button (click)="quickFilter.close();manageQuickFilters()" [value]="'MANAGE'"
                                        class="w-full sticky z-10 bottom-0 bg-card text-base px-1.5 py-2 hover:bg-gray-100">
                                        <div class="flex justify-between">
                                            <div><em class="ti ti-settings"></em>
                                                {{'manage_filter.text' | translate}}</div>
                                            <div class="flex items-center"><em
                                                    class="ti ti-arrow-narrow-right font-medium text-xl"></em></div>
                                        </div>
                                    </button>
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="flex items-center">
                            <button type="button" (click)="createNewJob(null)" *ngIf="permissions.newJob"
                                class="bg-primary text-base  px-4 py-3 h-9 flex gap-2 items-center border-gray-300 shadow-sm text-white font-medium rounded-l-md text-white-600 focus:outline-none">
                                {{'create.job.text' | translate}}
                            </button>
                            <div class="menu-button-divider"></div>
                            <button type="button" [matMenuTriggerFor]="createNew" *ngIf="permissions.newJob || permissions?.timesheetTimeoff"
                                class="bg-primary text-base  px-2 py-2.5 h-9 flex gap-2 items-center border-gray-300 shadow-sm text-white font-medium rounded-r-md text-white-600 focus:outline-none">
                                <i class="ti ti-chevron-down text-2xl text-white"></i>
                            </button>
                        </div>
                        <mat-menu #createNew="matMenu" class="primary-font text-base text-gray-500 font-normal create-mat-menu context-menu-wrapper">
                            <button class="text-gray-700 text-left w-full flex items-center text-base primary-font hover:bg-gray-100"
                                *ngIf="permissions.newJob" (click)="createNewJob(null)">
                                <i class="ti ti-briefcase text-2xl"></i>
                                <span>{{'text.new_job' | translate}}</span>
                            </button>
                            <button class="text-gray-700 text-left w-full flex items-center text-base primary-font hover:bg-gray-100"
                                *ngIf="permissions.newJob" (click)="createNewNonJobEvent(null)">
                                <i class="ti ti-calendar text-2xl"></i>
                                <span>{{'text.new_non_job_event' | translate}}</span>
                            </button>
                            <button class="text-gray-700 text-left w-full flex items-center text-base primary-font hover:bg-gray-100"
                                *ngIf="permissions?.timesheetTimeoff" (click)="createNewTimeoffEvent(null)">
                                <i class="ti ti-clock-x text-2xl"></i>
                                <span>{{'dispatchBoard.scheduler.new_event.dialog.new_timeoff' | translate}}</span>
                            </button>
                        </mat-menu>                        
                        <div class="divider"></div>
                        <div class="flex items-center">
                            <button (click)="openDispatchFilter('GRID')"
                                class="icon-button relative"
                                title="{{'text.filters' | translate}}">
                                <i class="ti ti-filter text-2xl"></i>
                            </button>
                            <button class="icon-button"
                                (click)="openSettingsDialog('GRID')"
                                title="{{'text.settings' | translate}}">
                                <i class="ti ti-settings text-2xl"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        <!-- Content -->
        <div class="flex w-full h-full">
            <div class="flex w-full h-full" id="dispatch-board">
                <as-split direction="horizontal" class="default-drag-handler" (dragEnd)='onMapViewDrag($event)'>
                    <as-split-area [size]="dispatchJobSplitSettings.size" [maxSize]="dispatchJobSplitSettings?.maxSize"
                        [minSize]="dispatchJobSplitSettings?.minSize" class="overflow-hidden bg-gray-50">
                        <as-split direction="{{dispatchJobSplitSettings.orientation}}" class="default-drag-handler">
                            <as-split-area [order]="dispatchJobSplitSettings.grid?.order || 1"
                                [size]="dispatchJobSplitSettings.grid.size"
                                [maxSize]="dispatchJobSplitSettings.grid.maxSize"
                                [minSize]="dispatchJobSplitSettings.grid.minSize" class="overflow-hidden bg-gray-50">
                                <div class="grid-wrapper">
                                    <div class="gridView" id="grid-splitter" class="flex flex-col h-full w-full">
                                        <!-- Grid Tbar -->
                                        <header class="flex flex-col bg-white z-99 w-full border-b border-gray-200">
                                            <div
                                                class="flex gap-4 justify-between bg-white h-18 my-0.5 w-full px-4 align-center items-center overflow-x-auto overflow-y-hidden zuper-scrollbar">
                                                <div class="w-48 h-full flex items-center jobType">
                                                    <ng-select
                                                      class="job-type-select w-inherit text-base text-gray-700 font-normal primary-font"
                                                      [items]="_dispatchBoardService.jobTypeOptions"
                                                      bindValue="value"
                                                      [(ngModel)]="gridTbar.jobType"
                                                      (change)="changeGridJobType()"
                                                      [searchable]="false"
                                                      [clearable]="false"
                                                      [appendTo]="'body'"
                                                      placeholder="{{ 'text.job_type' | translate }}">
                                                      <ng-template ng-label-tmp let-item="item">
                                                        <div class="truncate font-medium" [title]="item?.label | translate">
                                                          {{ item?.label | translate }}
                                                        </div>
                                                      </ng-template>
                                                  
                                                      <ng-template ng-option-tmp let-item="item">
                                                        <div class="truncate" [title]="item.label | translate">
                                                          {{ item.label | translate }}
                                                        </div>
                                                      </ng-template>
                                                    </ng-select>
                                                  </div>
                                                <div class="flex items-center justify-between"
                                                    [ngClass]="{'w-auto': gridViewType === 'tableView' && metaData?.grid.table_grid_position === 'BOTTOM'}">
                                                    <div class="flex items-center justify-center gap-3 p-3 pr-0 w-full mr-2"
                                                        *ngIf="gridViewType === 'tableView' && metaData?.grid.table_grid_position === 'BOTTOM'">
                                                        <mat-form-field appearance="fill" class="w-90">
                                                            <input matInput [(ngModel)]="gridSearchKeyword"
                                                                placeholder="{{'dispatchBoard.grid.tbar.job_search_placeholder' | translate}}"
                                                                (keyup)="applyGridSearch($event)">
                                                            <button *ngIf="gridSearchKeyword" matSuffix
                                                                mat-icon-button aria-label="Clear"
                                                                (click)="gridSearchKeyword=''; applyGridSearch($event, 'clear')">
                                                                <mat-icon>close</mat-icon>
                                                            </button>
                                                        </mat-form-field>
                                                    </div>
                                                    <button
                                                        *ngIf="!(gridViewType === 'tableView' && metaData?.grid.table_grid_position === 'BOTTOM')"
                                                        (click)="toggleGridSearch()"
                                                        class="icon-button"
                                                        title="{{'text.search' | translate}}">
                                                        <i class="ti ti-search text-2xl"></i>
                                                    </button>
                                                    <button (click)="openDispatchFilter('GRID')"
                                                        class="icon-button relative items-center"
                                                        [ngClass]="{'py-2': filterCount.grid > 0}"
                                                        title="{{'text.filters' | translate}}">
                                                        <i class="ti ti-filter text-2xl"></i>
                                                        <div *ngIf="filterCount.grid > 0"
                                                            class="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-primary-600 border-2 border-white rounded-full top-0 -right-2 dark:border-gray-900">
                                                            {{filterCount.grid}}</div>
                                                    </button>
                                                    <button [ngxTippy]="gridSortTemplate"
                                                        [tippyName]="'gridJobSortTippy'"
                                                        [tippyProps]="gridSortTippyProps"
                                                        class="icon-button"
                                                        title="{{'text.sort' | translate}}">
                                                        <i class="ti ti-arrows-sort text-2xl"></i></button>
                                                </div>
                                            </div>

                                            <!-- Search -->
                                            <div class="flex items-center justify-center gap-3 p-3 w-full"
                                                *ngIf="(openGridSearch || gridSearchKeyword.trim().length > 0) && !(gridViewType === 'tableView' && metaData?.grid.table_grid_position === 'BOTTOM')">
                                                <mat-form-field appearance="fill" class="w-full">
                                                    <input matInput [(ngModel)]="gridSearchKeyword" autoFocus
                                                        placeholder="{{'dispatchBoard.grid.tbar.job_search_placeholder' | translate}}"
                                                        (keyup)="applyGridSearch($event)">
                                                    <button *ngIf="gridSearchKeyword" matSuffix
                                                        mat-icon-button aria-label="Clear"
                                                        (click)="gridSearchKeyword=''; applyGridSearch($event, 'clear')">
                                                        <mat-icon>close</mat-icon>
                                                    </button>
                                                </mat-form-field>
                                            </div>
                                        </header>

                                        <!-- Grid  -->
                                        <div class="flex" id="card-view" class="w-full h-full py-1 flex-1"
                                            *ngIf="gridViewType === 'listView'">
                                            <bryntum-grid #cardView id="cardView" [data]="cardData"
                                                [cls]="'min-h-0'"
                                                [bodyCls]="'grid-body card-view'"
                                                [emptyText]="_utilityService.getLocaleValue('text.no_jobs_found', 'No Jobs Found')"
                                                [config]="cardConfig" [columns]="cardConfig?.columns || []"
                                                [stripeFeature]="false">
                                            </bryntum-grid>
                                        </div>

                                        <div class="flex" id="table-view" class="h-full w-inherit flex-1"
                                            *ngIf="gridViewType === 'tableView'">
                                            <bryntum-grid #tableView id="tableView"
                                                [emptyText]="_utilityService.getLocaleValue('text.no_jobs_found', 'No Jobs Found')"
                                                [columns]="tableConfig?.columns || []" [data]="tableGridData" [cls]="'min-h-0'"
                                                [stripeFeature]="true" [cellEditFeature]="false"
                                                [headerMenuFeature]="false" [cellMenuFeature]="false"
                                                [config]="tableConfig">
                                            </bryntum-grid>
                                        </div>
                                        <!-- Grid Bbar -->
                                        <footer class="flex flex-col bg-white z-99 w-full  border-t border-gray-200 overflow-x-auto zuper-scrollbar">
                                            <div class="flex gap-4 justify-between bg-white p-1 h-18 w-full border-b px-4 align-center items-center">
                                                <div class="flex items-center">
                                                    <button (click)="openSettingsDialog('GRID')"
                                                        class="icon-button"
                                                        title="{{'text.settings'| translate}}">
                                                        <i class="ti ti-settings text-2xl"></i></button>
                                                </div>
                                                <div class="flex gap-3 items-center">
                                                    <span>{{totalGridRecords}} {{'text.jobs' | translate}}</span>
                                                    <div class="flex items-center pageNumber">
                                                        <mat-form-field appearance="fill" class="w-16">
                                                            <input inputmode="numeric"
                                                                oninput="this.value = this.value.replace(/^0+/,'').replace(/\D+/g, '')"
                                                                [(ngModel)]="gridPageNumber"
                                                                (keyup)="updateGridPageNumber($event)"
                                                                (blur)="gridPageNumber = gridParam['page']" matInput>
                                                        </mat-form-field>
                                                    </div>
                                                    <span>{{'of' | translate}} {{totalGridPage}} {{'text.pages' | translate}}</span>
                                                </div>
                                                <div class="flex items-center justify-between mt-1.5">
                                                    <button [disabled]="loadingGridData"
                                                        (click)="gridPageIncrement('prev')"
                                                        class="icon-button"
                                                        title="{{'dispatchBoard.icons.tooltip.prev_page' | translate}}">
                                                        <i
                                                            class="ti ti-chevron-left text-2xl btnColor-black"></i></button>
                                                    <button [disabled]="loadingGridData"
                                                        (click)="gridPageIncrement('next')"
                                                        class="icon-button"
                                                        title="{{'dispatchBoard.icons.tooltip.next_page' | translate}}">
                                                        <i
                                                            class="ti ti-chevron-right text-2xl btnColor-black"></i></button>
                                                </div>
                                            </div>
                                        </footer>
                                    </div>
                                </div>
                            </as-split-area>
                            <as-split-area [order]="dispatchJobSplitSettings.scheduler?.order || 2" [visible]="this.dispatchJobSplitSettings.visible.scheduler"
                                [size]="dispatchJobSplitSettings.scheduler.size"
                                [maxSize]="dispatchJobSplitSettings.scheduler.maxSize"
                                [minSize]="dispatchJobSplitSettings.scheduler.minSize"
                                class="overflow-hidden bg-gray-50">
                                <div class="h-full flex flex-col bg-white z-99" id="scheduler">
                                    <form
                                        class="flex space-x-4 justify-between bg-white overflow-x-auto zuper-scrollbar h-20 w-full border-b px-4 align-center items-center"
                                        id="schedule-tbar" [formGroup]="schedulerFormGroup">
                                        <div class="w-full flex items-center justify-between">
                                            <div class="flex space-x-4 items-center justify-center">
                                                <div class="flex">
                                                    <!-- TODO: If config has multiple team config true, we have to enable below-->
                                                    <ng-select *ngIf="false" class="w-48" [items]="teams | async"
                                                        bindLabel="team_name" bindValue="team_uid"
                                                        formControlName="selectedTeam" [clearable]="false"
                                                        [multiple]="true" [searchable]="true" [hideSelected]="false"
                                                        [closeOnSelect]="false" (change)="onTeamChange()">
                                                        <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                                            let-index="index">
                                                            <input id="item-{{index}}" type="checkbox"
                                                                [ngModelOptions]="{standalone: true}"
                                                                [ngModel]="item$.selected" />
                                                            {{item.team_name}}
                                                        </ng-template>
                                                        <ng-template ng-multi-label-tmp let-items="items"
                                                            let-clear="clear">
                                                            <div class="ng-value" *ngFor="let item of items | slice:0:2"
                                                                [ngClass]="{'hidden' : items.length>2}">
                                                                <span
                                                                    class="ng-value-label text-base">{{item.team_name}}</span>
                                                                <span class="ng-value-icon right text-base"
                                                                    (click)="clear(item)" aria-hidden="true">×</span>
                                                            </div>
                                                            <div class="ng-value" *ngIf="items.length > 2">
                                                                <span class="ng-value-label text-base">{{items.length}} {{'text.teams_selected' | translate | lowercase}}
                                                                </span>
                                                            </div>
                                                        </ng-template>
                                                    </ng-select>
                                                    <!-- TODO: If config has multiple team config false, we have to enable below-->
                                                    <ng-select class="w-48 teamSelector text-gray-700 dispatchPicker" #teamSelect
                                                        [items]="teams | async" bindLabel="team_name"
                                                        bindValue="team_uid" formControlName="selectedTeam"
                                                        placeholder="{{'text.choose_a_team' | translate}}"
                                                        [multiple]="false" [clearable]="false" [searchable]="true"
                                                        [hideSelected]="false" [appendTo]="'body'" [virtualScroll]="true"
                                                        [closeOnSelect]="true" (open)="onTeamPickerOpen()"
                                                        [notFoundText]="'dispatchBoard.scheduler.team_select.empty' | translate"
                                                        [loading]="teamPickerLoading" [typeahead]="teamValueSubject"
                                                        (search)="onTeamSearch()"
                                                        (scrollToEnd)="teamPickerScrollToEnd()"
                                                        (change)="teamSelect.blur();onTeamChange()">
                                                    </ng-select>
                                                </div>
                                                <div
                                                    class="h-10 relative flex items-center rounded-md bg-white shadow-sm md:items-stretch schedulerDateField">
                                                    <div class="pointer-events-none absolute inset-0 rounded-md border border-gray-300"
                                                        aria-hidden="true"></div>
                                                    <button type="button" (click)="schedulerDateIncrement('prev')"
                                                        [disabled]="schedulerDatePrevBtn"
                                                        class="flex items-center justify-center border-r rounded-l-md py-2 pl-3 pr-4 text-gray-400 focus:relative md:w-9 md:px-2 hover:bg-gray-100 rounded-lg h-10 rounded-r-none">
                                                        <i class="ti ti-chevron-left text-2xl"></i>
                                                    </button>
                                                    <div *ngIf="schedulerFormGroup.get('schedulerView').value === 'DAY'"
                                                        class="flex items-center">
                                                        <input readonly [matDatepicker]="scheduleDatepicker"
                                                            [datePickerFormat]="_utilityService?.dateFormat"
                                                            class="block w-24 text-center pt-0.5  px-1 bg-white cursor-pointer text-base font-medium"
                                                            placeholder="{{'text.choose_date.header' | translate}}"
                                                            formControlName="schedulerDate"
                                                            (click)="scheduleDatepicker.open()"
                                                            (dateChange)="onSchedulerDateChange()">
                                                        <mat-datepicker #scheduleDatepicker></mat-datepicker>
                                                    </div>
                                                    <div *ngIf="schedulerFormGroup.get('schedulerView').value !== 'DAY'"
                                                        class="flex items-center w-fit">
                                                        <div
                                                            class="flex items-center cursor-pointer p-2 mt-0.5">
                                                            <mat-date-range-input [rangePicker]="scheduleRangePicker"
                                                                (click)="scheduleRangePicker.open()" color="bg-indigo"
                                                                class="flex items-center w-full rounded-md bg-white shadow-xs cursor-pointer text-base font-medium">
                                                                <input matStartDate readonly
                                                                    [datePickerFormat]="_utilityService?.dateFormat"
                                                                    placeholder="{{'text.choose_date.header' | translate}}"
                                                                    formControlName="scheduleStartDate"
                                                                    class="cursor-pointer text-center">
                                                                <input matEndDate readonly
                                                                    [datePickerFormat]="_utilityService?.dateFormat"
                                                                    placeholder="{{'text.choose_date.header' | translate}}"
                                                                    formControlName="scheduleEndDate"
                                                                    class="cursor-pointer text-center">
                                                            </mat-date-range-input>
                                                            <mat-date-range-picker #scheduleRangePicker>
                                                                <mat-date-range-picker-actions>
                                                                    <div
                                                                        class="flex w-full justify-end border-t border-gray-300 px-3 pt-4 pb-2">
                                                                        <div class="flex justify-around space-x-4">
                                                                            <button type="button"
                                                                                matDateRangePickerCancel
                                                                                class="px-6 flex items-center py-2 border b-1 border-gray-300  text-black shadow-xs text-base font-small rounded-md  bg-white focus:outline-none btn-small">
                                                                                {{'cancel.text'
                                                                                |
                                                                                translate}}</button>
                                                                            <button type="submit"
                                                                                matDateRangePickerApply
                                                                                (click)="onSchedulerDateRangeChange()"
                                                                                class="bg-primary px-6 flex items-center py-2 border b-1 shadow-xs text-white font-small text-base rounded-md text-white-600 focus:outline-none btn-small">{{'text.apply'
                                                                                | translate}}</button>
                                                                        </div>
                                                                    </div>
                                                                </mat-date-range-picker-actions>
                                                            </mat-date-range-picker>
                                                        </div>
                                                    </div>
                                                    <button type="button" (click)="schedulerDateIncrement('next')"
                                                        [disabled]="schedulerDateNextBtn"
                                                        class="flex items-center justify-center rounded-r-md border-l py-2 pl-4 pr-3 text-gray-400 focus:relative md:w-9 md:px-2 hover:bg-gray-100 rounded-lg h-10 rounded-l-none">
                                                        <i class="ti ti-chevron-right text-2xl"></i>
                                                    </button>
                                                </div>

                                                <div class="flex items-center justify-center gap-1 cursor-pointer"
                                                    *ngIf="selectedTeamTimezone && _dispatchBoardService.customTimezone === selectedTeamTimezone"
                                                    title="{{'text.timezone' | translate}}">
                                                    <i class="ti ti-clock text-2xl"></i>
                                                    <span class="text-lg font-medium" title="{{selectedTeamTimezone}}">{{selectedTeamTimezone}}</span>
                                                </div>
                                            </div>
                                            <div class="flex gap-4 items-center">
                                                <div class="flex p-2 items-center space-x-4">
                                                    <button class="h-10 px-3 font-medium border border-gray-300 primary-font text-base text-gray-700 cursor-pointer hover:bg-gray-100 rounded" (click)="scrollSchedulerToToady()">
                                                        {{'daterange.range.today.label' | translate}}
                                                    </button>
                                                    <ng-select class="scheduler-view-select w-28 text-base text-gray-700 font-normal primary-font"
                                                        [items]="_dispatchBoardService.schedulerViewOptions" bindValue="value" formControlName="schedulerView"
                                                        (change)="onSchedulerViewChange()" [searchable]="false" [clearable]="false" [appendTo]="'body'">
                                                        <ng-template ng-label-tmp let-item="item">
                                                            <div class="truncate font-medium" [title]="item?.label | translate">
                                                                {{ item?.label | translate }}
                                                            </div>
                                                        </ng-template>
                                                    
                                                        <ng-template ng-option-tmp let-item="item">
                                                            <div class="truncate" [title]="item.label | translate">
                                                                {{ item.label | translate }}
                                                            </div>
                                                        </ng-template>
                                                    </ng-select>
                                                    <div class="flex items-center">
                                                        <div class="inline-flex h-10 rounded-md border border-gray-300 schedulerZoomActions"
                                                            role="group">
                                                            <button type="button" [disabled]="schedulerZoomInBtnState"
                                                                title="{{'dispatchBoard.icons.tooltip.scheduler.zoomin' | translate}}"
                                                                (click)="setSchedulerZoom('zoomIn')"
                                                                class="px-2 border-r border-gray-300 font-medium rounded-l-md flex items-center text-gray-700 hover:bg-gray-100 focus:z-10">
                                                                <i class="ti ti-zoom-in text-2xl text-gray-700"></i>
                                                            </button>
                                                            <button type="button" [disabled]="schedulerZoomOutBtnState"
                                                                title="{{'dispatchBoard.icons.tooltip.scheduler.zoomout' | translate}}"
                                                                (click)="setSchedulerZoom('zoomOut')"
                                                                class="px-2 font-medium rounded-r-md flex items-center text-gray-700 hover:bg-gray-100 focus:z-10">
                                                                <i class="ti ti-zoom-out text-2xl text-gray-700"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="divider"></div>
                                                <div class="flex items-center py-2">
                                                    <button [ngxTippy]="schedulerSearch"
                                                        [tippyProps]="schedulerSearchTippyProps"
                                                        [tippyName]="'tippyschedulerSearch'"
                                                        class="icon-button relative"
                                                        title="{{'text.search' | translate}}">
                                                        <i class="ti ti-search text-2xl text-gray-700"></i>
                                                        <div class="w-2 h-2 bg-primary-600 rounded-full absolute top-1 right-1 z-10" *ngIf="appliedSchedulerSearchKeyword?.length && !schedulerSearchTippyInstance?.state?.isVisible"></div>
                                                    </button>
                                                    <button (click)="openDispatchFilter('SCHEDULER')"
                                                        class="icon-button relative"
                                                        [ngClass]="{'py-2': filterCount.scheduler > 0}"
                                                        title="{{'text.filters' | translate}}">
                                                        <i class="ti ti-filter text-2xl text-gray-700"></i>
                                                        <div *ngIf="filterCount.scheduler > 0"
                                                            class="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-primary-600 border-2 border-white rounded-full top-0 -right-2 dark:border-gray-700">
                                                            {{filterCount.scheduler}}</div>
                                                    </button>
                                                    <button (click)="openSettingsDialog('SCHEDULER')"
                                                        class="icon-button"
                                                        title="{{'text.settings' | translate}}">
                                                        <em class="ti ti-settings text-2xl text-gray-700"></em>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    <div id="scheduler" class="flex flex-col w-full"
                                        [ngClass]="{'order-1' : this.metaData?.grid.table_grid_position === 'BOTTOM'}">
                                        <bryntum-scheduler-pro #schedulerpro id="schedulerpro" [autoAdjustTimeAxis]="false"
                                            [viewPreset]="schedulerProConfig?.viewPreset" [barMargin]="5"
                                            [mode]="'horizontal'" [createEventOnDblClick]="false"
                                            [columns]="schedulerProConfig?.columns || []"
                                            [eventRenderer]="schedulerProConfig.eventRenderer"
                                            [timeZone]="selectedTimezone"
                                            [config]="schedulerProConfig"></bryntum-scheduler-pro>
                                    </div>
                                </div>
                            </as-split-area>
                        </as-split>
                    </as-split-area>
                    <div *asSplitGutter class="h-full min-w-full relative gutter-wrapper">
                        <div class="w-12 h-12 flex items-center rounded-full z-99 absolute top-1/2 -left-4"
                            [ngClass]="{'gutter-content': dispatchJobSplitSettings.gutter.toggleState[1] === 'neutral' }">
                            <button 
                                (click)="updateSplitVisibility(1, 'left')"
                                [ngClass]="{'opacity-0 pointer-events-none': dispatchJobSplitSettings.gutter.toggleState[1] === 'left' 
                                    || (gridViewType === 'tableView' && metaData?.grid.table_grid_position === 'BOTTOM' && dispatchJobSplitSettings.gutter.toggleState[1] === 'neutral')}"
                                class="h-full w-1/2 border-gray-200 bg-gray-100 hover:bg-gray-200 rounded-l-full flex items-center justify-center group">
                                <i class="ti ti-chevron-left text-2xl group-hover:text-sky-600"></i>
                            </button>
                            <button 
                                (click)="updateSplitVisibility(1, 'right')"
                                [ngClass]="{'opacity-0 pointer-events-none': dispatchJobSplitSettings.gutter.toggleState[1] === 'right'}"
                                class="h-full w-1/2 border-gray-200 bg-gray-100 hover:bg-gray-200 rounded-r-full flex items-center justify-center group">
                                <i class="ti ti-chevron-right text-2xl group-hover:text-sky-600"></i>
                            </button>
                        </div>
                    </div>
                    <as-split-area class="overflow-hidden bg-gray-50 relative"
                        [order]="dispatchJobSplitSettings.map?.order || 3"
                        [size]="dispatchJobSplitSettings.map.size"
                        [maxSize]="dispatchJobSplitSettings.map.maxSize"
                        [minSize]="dispatchJobSplitSettings.map.minSize"
                        *ngIf="isMapViewEnabled && moduleAccess.map">
                        <div id="map-view" class="flex flex-col z-99 w-full h-full" #mapContainer>
                            <div class="w-full h-full"
                                *ngIf="isMapViewEnabled && moduleAccess.map && _dispatchBoardService.activeDispatchTab === 'JOBS'">
                                <app-map-main [isDispatch]="true" [mapView]="mapViewData" [timezone]="selectedTimezone"
                                    [colorProfileOptions]="mapColorProfileOptions"
                                    (eventChange)="onMapEventChange($event)"
                                    (jobSelected)="onJobClickFromMap($event)"></app-map-main>
                            </div>
                        </div>
                    </as-split-area>
                </as-split>
            </div>
        </div>
    </div>
</div>

<!-- Routes -->
<div class="w-full h-full" *ngIf="selectedDispatchTab === 'ROUTES'">
    <app-dispatch-board-routes [currentTab]="currentRouteTab" [holidays]="holidays" [prefillConfig]="routePrefillConfig"
        (dispatchTabChange)="onDispatchTabChange($event)"></app-dispatch-board-routes>
</div>

<!-- Dispatch filter drawer -->
<app-dispatch-filter-drawer class="dispatch-board-filter" [isMapViewEnabled]="isMapViewEnabled" [filterOptionalValues]="dispatchFilterDrawerData.filterOptionalValues"
    [openFilter]="dispatchFilterDrawerData.openFilter" [ngClass]="{'-z-1': !dispatchFilterDrawerData.openFilter, 'z-auto': dispatchFilterDrawerData.openFilter }" [currentTab]="'JOBS'"
    [dispatchFilterValues]="dispatchFilterDrawerData.dispatchFilterValues" [saveFilterByDefault]="dispatchFilterDrawerData.saveFilterByDefault" [hideSaveFilter]="dispatchFilterDrawerData.hideSaveFilter"
    [isNewFilter]="dispatchFilterDrawerData.addNewFilter" [selectedModule]="dispatchFilterDrawerData.selectedModule" [additionalFilters]="dispatchFilterDrawerData?.additionalFilters"
    [moduleAccess]="moduleAccess" (filterDrawerEmitter)="filterDrawerEmitter($event)" [filterTabs]="getDispatchFilterTabs()" [selectedTeamUid]="selectedTeam"></app-dispatch-filter-drawer>

<!-- Grid sort template for tippy -->
<ng-template #gridSortTemplate>
    <div class="text-base primary-font text-gray-700 font-normal">
        <div class="px-4 py-3 border-b border-gray-300">
            <span class="text-lg font-semibold">{{ 'text.sort' | translate }}</span>
        </div>
        <div class="w-48 flex flex-col">
            @if (gridParam?.['type'] !== 'UNSCHEDULED') {
            <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
                [ngClass]="{ 'bg-gray-100': sortOptions.grid?.sort_by === 'scheduled_start_time' }"
                (click)="setGridSort('sort_by', 'scheduled_start_time')">
                <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
                   'font-semibold': sortOptions.grid?.sort_by === 'scheduled_start_time',
                   'font-normal': sortOptions.grid?.sort_by !== 'scheduled_start_time'}">
                    <span class="inline-block w-5 text-center">
                        @if (sortOptions.grid?.sort_by === 'scheduled_start_time') {
                        <i class="ti ti-check text-xl"></i>
                        }
                    </span>
                    <span>{{ 'text.scheduled_date' | translate }}</span>
                </div>
            </div>
            }

            <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
                [ngClass]="{ 'bg-gray-100': sortOptions.grid?.sort_by === 'due_date' }"
                (click)="setGridSort('sort_by', 'due_date')">
                <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
                 'font-semibold': sortOptions.grid?.sort_by === 'due_date',
                 'font-normal': sortOptions.grid?.sort_by !== 'due_date'}">
                    <span class="inline-block w-5 text-center">
                        @if (sortOptions.grid?.sort_by === 'due_date') {
                        <i class="ti ti-check text-xl"></i>
                        }
                    </span>
                    <span>{{ 'due.date.text' | translate }}</span>
                </div>
            </div>

            <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
                [ngClass]="{ 'bg-gray-100': sortOptions.grid?.sort_by === 'work_order_number' }"
                (click)="setGridSort('sort_by', 'work_order_number')">
                <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
                 'font-semibold': sortOptions.grid?.sort_by === 'work_order_number',
                 'font-normal': sortOptions.grid?.sort_by !== 'work_order_number'}">
                    <span class="inline-block w-5 text-center">
                        @if (sortOptions.grid?.sort_by === 'work_order_number') {
                        <i class="ti ti-check text-xl"></i>
                        }
                    </span>
                    <span>{{ 'dispatchBoard.grid.tbar.sort.job_id' | translate }}</span>
                </div>
            </div>

            <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
                [ngClass]="{ 'bg-gray-100': sortOptions.grid?.sort_by === 'job_priority' }"
                (click)="setGridSort('sort_by', 'job_priority')">
                <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
                 'font-semibold': sortOptions.grid?.sort_by === 'job_priority',
                 'font-normal': sortOptions.grid?.sort_by !== 'job_priority'}">
                    <span class="inline-block w-5 text-center">
                        @if (sortOptions.grid?.sort_by === 'job_priority') {
                        <i class="ti ti-check text-xl"></i>
                        }
                    </span>
                    <span>{{ 'text.job_priority' | translate }}</span>
                </div>
            </div>

            <hr class="border-gray-200 my-1" />

            <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
                [ngClass]="{ 'bg-gray-100': sortOptions.grid?.sort === 'ASC' }" (click)="setGridSort('sort', 'ASC')">
                <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
                 'font-semibold': sortOptions.grid?.sort === 'ASC',
                 'font-normal': sortOptions.grid?.sort !== 'ASC'}">
                    <span class="inline-block w-5 text-center">
                        @if (sortOptions.grid?.sort === 'ASC') {
                        <i class="ti ti-check text-xl"></i>
                        }
                    </span>
                    <span>{{ 'dispatchBoard.grid.tbar.sort.asc' | translate }}</span>
                </div>
            </div>

            <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
                [ngClass]="{ 'bg-gray-100': sortOptions.grid?.sort === 'DESC' }" (click)="setGridSort('sort', 'DESC')">
                <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
                 'font-semibold': sortOptions.grid?.sort === 'DESC',
                 'font-normal': sortOptions.grid?.sort !== 'DESC'
               }">
                    <span class="inline-block w-5 text-center">
                        @if (sortOptions.grid?.sort === 'DESC') {
                        <i class="ti ti-check text-xl"></i>
                        }
                    </span>
                    <span>{{ 'dispatchBoard.grid.tbar.sort.desc' | translate }}</span>
                </div>
            </div>

            <div class="p-4">
                <button
                    class="w-full bg-primary hover:bg-primary-dark text-white font-medium px-6 py-2 rounded-md transition-colors duration-200"
                    type="button" (click)="applyGridSort()">
                    {{ 'text.apply' | translate }}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<!-- User sort template for tippy -->
<ng-template #userSortTemplate let-sortOptions="sortOptions" let-setUserSort="setUserSort"
    let-showSkillSubMenu="showSkillSubMenu" let-applyUserSort="applyUserSort"
    let-hideUserSkillSubMenu="hideUserSkillSubMenu">
    <div class="text-base primary-font text-gray-700 font-normal">
        <div class="px-4 py-3 border-b border-gray-300">
            <span class="text-lg font-semibold">{{ 'text.sort' | translate }}</span>
        </div>
        <div class="w-48 flex flex-col">
            <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
                [ngClass]="{ 'bg-gray-100': sortOptions?.user?.sort_by === 'name' }"
                (click)="resetUserSortSkill();setUserSort('sort_by', 'name')">
                <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
                 'font-semibold': sortOptions?.user?.sort_by === 'name',
                 'font-normal': sortOptions?.user?.sort_by !== 'name' }">
                    <span class="inline-block w-5 text-center">
                        @if (sortOptions?.user?.sort_by === 'name') {
                        <i class="ti ti-check text-xl"></i>
                        }
                    </span>
                    <span>{{ 'name.text' | translate }}</span>
                </div>
            </div>

            <div class="relative overflow-hidden" (mouseenter)="cancelUserSkillHideSubMenu()" (mouseleave)="onSkillParentLeave()">
                <div class="flex flex-col cursor-pointer hover:bg-gray-50 px-4 py-3"
                    [ngClass]="{ 'bg-gray-100': sortOptions?.user?.sort_by === 'skill', 'bg-white': userSortData.skillSubMenu?.isOpened && sortOptions?.user?.sort_by !== 'skill' }" #skillTriggerRef
                    (mouseenter)="showUserSkillSubMenu(skillTriggerRef)">
                    <div class="flex items-center justify-between w-full">
                        <div class="flex items-center gap-2 text-base text-gray-700" 
                            [ngClass]="{ 'font-semibold': sortOptions?.user?.sort_by === 'skill', 'font-normal': sortOptions?.user?.sort_by !== 'skill' }">
                            <span class="inline-block w-5 text-center">
                                @if (sortOptions?.user?.sort_by === 'skill') {
                                <i class="ti ti-check text-xl"></i>
                                }
                            </span>
                            <span>{{ 'text.skill' | translate }}</span>
                        </div>
                        <i class="ti ti-chevron-right text-xl text-gray-400 hover:text-gray-700"></i>
                    </div>
                    @if (sortOptions?.user?.sort_by === 'skill' && userSortData?.selectedSkillName) {
                        <span class="inline-block ml-[1.75rem] w-10/12 truncate text-gray-500 text-md" title="{{ userSortData.selectedSkillName }}">{{userSortData?.selectedSkillName}}</span>
                    }
                </div>
            </div>

            <hr class="border-gray-200 my-1" />

            <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
                [ngClass]="{ 'bg-gray-100': sortOptions?.user?.sort === 'ASC' }" (click)="setUserSort('sort', 'ASC')">
                <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
                 'font-semibold': sortOptions?.user?.sort === 'ASC',
                 'font-normal': sortOptions?.user?.sort !== 'ASC' }">
                    <span class="inline-block w-5 text-center">
                        @if (sortOptions?.user?.sort === 'ASC') {
                        <i class="ti ti-check text-xl"></i>
                        }
                    </span>
                    <span>{{ 'dispatchBoard.grid.tbar.sort.asc' | translate }}</span>
                </div>
            </div>

            <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
                [ngClass]="{ 'bg-gray-100': sortOptions?.user?.sort === 'DESC' }" (click)="setUserSort('sort', 'DESC')">
                <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
                 'font-semibold': sortOptions?.user?.sort === 'DESC',
                 'font-normal': sortOptions?.user?.sort !== 'DESC' }">
                    <span class="inline-block w-5 text-center">
                        @if (sortOptions?.user?.sort === 'DESC') {
                        <i class="ti ti-check text-xl"></i>
                        }
                    </span>
                    <span>{{ 'dispatchBoard.grid.tbar.sort.desc' | translate }}</span>
                </div>
            </div>

            <div class="p-4">
                <button
                    class="w-full bg-primary hover:bg-primary-dark text-white font-medium px-6 py-2 rounded-md transition-colors duration-200"
                    type="button" (click)="applyUserSort()">
                    {{ 'text.apply' | translate }}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<!-- User sort skill submenu -->
<ng-template #skillSubMenuTemplate>
    <div class="relative w-64 z-10 primary-font" (mouseenter)="cancelUserSkillHideSubMenu()"
        (mouseleave)="hideUserSkillSubMenu()">
        <!-- Search in submenu -->
        <div class="p-3 border-b border-gray-100">
            <div class="relative flex items-center">
                <i class="ti ti-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-base"></i>
                <input type="text" placeholder="{{'text.search.skill' | translate}}"
                    [(ngModel)]="userSortData.skillSubMenu.searchKeyword" (ngModelChange)="onUserSortSkillSearch()"
                    class="w-full pl-8 pr-9 py-2.5 rounded-md border border-gray-200 focus:outline-none text-base primary-font text-gray-700" />
                @if (userSortData.skillSubMenu.searchKeyword) {
                <button
                    class="absolute right-2 w-6 h-6 pb-1 text-center rounded-full hover:bg-gray-100 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
                    (click)="userSortData.skillSubMenu.searchKeyword = ''; onUserSortSkillSearch()">
                    <i class="ti ti-x text-base"></i>
                </button>
                }
            </div>
        </div>

        <!-- Skills List - Scrollable -->
        <div class="max-h-64 overflow-y-auto py-1">
            @for (skill of userSortData.skillSubMenu.filteredSkillset; track skill?.skillset_uid) {
            <div class="px-3 py-3 hover:bg-gray-50 cursor-pointer flex items-center justify-between" (click)="selectUserSortSkill(skill)">
                <span class="text-gray-700 text-base primary-font font-normal flex items-center gap-2 overflow-hidden">
                    <span class="inline-block w-5 text-center">
                        @if (skill.selected) {
                        <i class="ti ti-check text-xl"></i>
                        }
                    </span>
                    <span class="block truncate" title="{{skill?.skillset_name}}">{{ skill?.skillset_name }}</span>
                </span>
            </div>
            } @empty {
            <div class="px-3 py-3 text-gray-700 text-center primary-font text-base font-normal">{{'text.skillsets.not.found' | translate}}</div>
            }
        </div>
    </div>
</ng-template>

@if (userSortData.isOpened) {
<div #userSortTippyWrapper class="hidden">
    <ng-container *ngTemplateOutlet="userSortTemplate; context: userSortTemplateContext"></ng-container>
</div>
}

@if (userSortData.skillSubMenu.isOpened) {
<div #userSkillSubMenuTippyWrapper>
    <ng-container *ngTemplateOutlet="skillSubMenuTemplate; context: userSortTemplateContext"></ng-container>
</div>
}

<!-- Job preview -->
<preview-data [drawerOpen]="openDrawer" [previewDrawerName]="'dispatch_preview'" [module]="previewDataModule" [hidden]="!openDrawer"
    [moduleUID]="jobUid" [options]="previewDataOptions" (eventEmitter)="previewDataEventHandler($event)">
</preview-data>

<!-- New Job Form -->
<app-new-job [openDrawer]="openNewJobDrawer" [timezone]="selectedTimezone" [jobObject]="newJobPrefillData"
    [jobData]="cloneJobData" (jobFormEmitter)="jobFormEmitHandler($event)"></app-new-job>

<!-- New Non Job Event Form -->
<create-non-job-event [openDrawer]="nonJobEventCreateDrawerData?.openDrawer" [timezone]="selectedTimezone" [options]="nonJobEventCreateDrawerData?.options"
    [eventData]="nonJobEventCreateDrawerData?.eventData" (actionEmitter)="nonJobEventEmitHandler($event)"></create-non-job-event>

<!-- Non nob event details -->
<non-job-event-details [nonJobEventUid]="nonJobEventDetailsDrawerData?.nonJobEventUid" [openDrawer]="nonJobEventDetailsDrawerData?.openDrawer" [options]="nonJobEventDetailsDrawerData?.options" 
    [drawerName]="nonJobEventDetailsDrawerData?.drawerName" [timezone]="selectedTimezone" (actionEmitter)="nonJobEventDetailsDrawerEmitter($event)"></non-job-event-details>

<!-- Color Profiles -->
<create-color-profile [openDrawer]="colorProfiletCreateDrawerData?.openDrawer" [drawerName]="colorProfiletCreateDrawerData?.drawerName" (actionEmitter)="colorProfileEventEmitter($event)"></create-color-profile>

<!-- Scheduler search tippy -->
<ng-template #schedulerSearch let-hide>
    <div class="w-80 h-20 flex">
        <div class="flex items-center justify-center gap-3 p-3 w-full">
            <mat-form-field appearance="fill" class="w-full">
                <input matInput [(ngModel)]="schedulerSearchKeyword" id="schedulerJobSearch_JOBS" autocomplete="off"
                    placeholder="{{'dispatchBoard.grid.tbar.job_search_placeholder' | translate}}"
                    (keyup)="applySchedulerSearch($event)">
                <button *ngIf="schedulerSearchKeyword" matSuffix mat-icon-button aria-label="Clear"
                    (click)="schedulerSearchKeyword=''; applySchedulerSearch($event, 'clear')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
    </div>
</ng-template>

<!-- Scheduler new event dialog content  -->
<ng-template #schedulerNewEventDialogContent let-hide let-data>
    <div class="font-semibold text-xl flex justify-between border-b border-b-gray-300 zuper-dialog-header">
        <h2>{{'dispatchBoard.scheduler.new_event.dialog.title' | translate}}</h2>
        <button mat-icon-button aria-label="close dialog" (click)="closeSchedulerEventDialog()" tabindex="-1">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="p-7">
        <div class="bg-white flex flex-col gap-4 items-center">
            <button *ngIf="data?.showNewJob" (click)="createNewJobEvent(data?.dragData)"
                [disabled]="data?.blockJobsOnHoliday"
                class="text-gray-700 flex items-center space-x-3 w-full bg-white hover:bg-gray-100 focus:outline-none rounded-lg border border-gray-200 text-sm font-medium p-5 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                [ngClass]="{'cursor-not-allowed': data.blockJobsOnHoliday, 'cursor-pointer': !data.blockJobsOnHoliday}">
                <i class="ti ti-briefcase text-2xl"
                    [ngClass]="{'schedulerDragNewJob cursor-not-allowed': data.blockJobsOnHoliday, 'cursor-pointer': !data.blockJobsOnHoliday}"></i>
                <span class="text-lg font-medium">{{'jobs.new.title' | translate}}</span>
            </button>
            <button *ngIf="data?.showNewNonJobEvent" (click)="createNewNonJobEvent(data?.dragData)"
                class="text-gray-700 flex items-center space-x-3 w-full bg-white cursor-pointer hover:bg-gray-100 focus:outline-none rounded-lg border border-gray-200 text-sm font-medium p-5 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">
                <i class="ti ti-calendar text-2xl"></i>
                <span class="text-lg font-medium">{{'non_job_event.new.title' | translate}}</span>
            </button>
            <button *ngIf="data?.showNewTimeoff" (click)="createNewTimeoffEvent(data?.dragData)"
                class="text-gray-700 flex items-center space-x-3 w-full bg-white cursor-pointer hover:bg-gray-100 focus:outline-none rounded-lg border border-gray-200 text-sm font-medium p-5 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">
                <i class="ti ti-clock-x text-2xl"></i>
                <span class="text-lg font-medium">{{'dispatchBoard.scheduler.new_event.dialog.new_timeoff' |
                    translate}}</span>
            </button>
        </div>
        <div class="flex items-center space-x-3 max-w-96 mt-2" *ngIf="data.blockJobsOnHoliday">
            <i class="ti ti-alert-triangle text-red-500 text-2xl cursor-default"></i>
            <span
                class="text-red-500 font-medium text-base cursor-default">{{'dispatchBoard.scheduler.error.block_new_job_on_holiday'
                | translate}} : {{data.holidayName}}</span>
        </div>
    </div>

</ng-template>

<!-- Employee search tippy -->
<div class="w-80 h-20 hidden" #employeeSearch>
    <div class="flex items-center justify-center gap-3 p-3 w-full">
        <mat-form-field appearance="fill" class="w-full">
            <input matInput [(ngModel)]="employeeSearchKeyword" id="schedulerEmpSearch_JOBS" autocomplete="off"
                placeholder="{{'text.search_user' | translate}}"
                (keyup)="applyEmployeeSearch($event)">
            <button *ngIf="employeeSearchKeyword" matSuffix mat-icon-button aria-label="Clear"
                (click)="employeeSearchKeyword=''; applyEmployeeSearch($event, 'clear')">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </div>
</div>

<!-- Employee Details -->
<preview-data [drawerOpen]="empDetailsDrawer.drawerOpen" [module]="empDetailsDrawer.module"
    [previewDrawerName]="'dispatch_emp_preview'" [moduleUID]="empDetailsDrawer.moduleUID"
    [options]="previewDataOptions" (eventEmitter)="empDetailsDrawerEventHandler($event)">
</preview-data>

<!-- No Team Created Alert -->
<ng-template #noTeamAlertDialogContent let-hide>
    <div class="w-full h-full">
        <div class="w-full h-7/12">
            <img class="w-full h-7/12" src="assets/images/png/team_placeholder.png" alt="">
        </div>
        <div class="px-2 pb-6 flex flex-col justify-center items-center space-y-5">
            <div class="flex flex-col space-y-1 justify-center items-center">
                <span class="font-semibold text-xl">{{'dispatchBoard.scheduler.no_team.alert.title' | translate}}</span>
                <span class="text-gray-600 text-lg">{{'dispatchBoard.scheduler.no_team.alert.message' |
                    translate}}</span>
            </div>
            <div class="flex items-center space-x-4">
                <button type="button"(click)=goBackFromCreateTeamAlert() class="px-6 py-2 border b-1 hover:bg-gray-100 border-gray-300 rounded-md cursor-pointer">{{'text.go_back'
                    | translate}}</button>
                <button type="button" (click)="createNewTeam()"
                class="bg-primary px-6 flex items-center py-2 border b-1 border-gray-300 shadow-sm text-white font-small rounded-md text-white-600 focus:outline-none btn-small">
                <i class="ti ti-plus text-2xl mr-2"></i> {{'create.team.text' |
                translate}}</button>
            </div>
        </div>
    </div>
</ng-template>

<!-- Route Details -->
<div class="flex flex-auto h-full routesPreviewWrapper">
    <zuper-drawer class="shadow-none routesPreview" [name]="routePreviewDrawerData.drawerName" [mode]="'over'"
        [fixed]="true" [position]="'right'" [transparentOverlay]="false"
        (openedChanged)="routeDetailsDrawerEvent($event)">
        <app-route-details *ngIf="routePreviewDrawerData.show" [data]="routePreviewDrawerData.routeDetailsUid"
            [parentModule]="'dispatch'" id="dispatch-route-details"
            (actionComplete)="routeDetailsEvent($event)"></app-route-details>
    </zuper-drawer>
</div>

<!-- Map Legend -->
 <div class="legend-wrapper absolute bottom-3 right-14 text-base font-normal text-gray-700 primary-font max-w-3/4 overflow-hidden whitespace-nowrap" 
    #mapLegendContainer
    *ngIf="_dispatchBoardService.activeDispatchTab === 'JOBS'">
     <div class="w-inherit bg-white shadow border expandable-panel py-2 px-4 flex items-center space-x-4 overflow-hidden justify-between rounded-l" id="map-legend-bar">
        <div class="flex-1 flex-shrink-0 flex items-center overflow-hidden whitespace-nowrap" #mapLegendWrapper *ngIf="mapLegendData.legendDetails?.length">
            <div *ngFor="let legendDetail of mapLegendData.legendDetails; let i = index" class="flex-shrink-0 whitespace-nowrap"
                [ngClass]="{'ml-3.5': i !== 0}" #mapLegendItems>
                <div class="flex items-center space-x-2">
                    <div class="flex items-center space-x-2 w-8 h-8 justify-center rounded" [style.background]="legendDetail?.color">
                        <i class="ti text-2xl cursor-default" [style.color]="legendDetail?.textColor" [ngClass]="legendDetail?.icon"></i>
                    </div>
                    <span>{{legendDetail?.name}}</span>
                </div>
            </div>
        </div>
        <div class="flex-0 flex items-center space-x-2">
            <span class="font-medium" *ngIf="mapLegendData.extraCount">+ {{mapLegendData.extraCount}} {{'text.more' | translate}}</span>
            <div class="flex-shrink-0 flex-0 text-blue font-medium cursor-pointer" (click)="openColorProfileDrawer()">Open Color Profile</div>
        </div>
     </div>
</div>